import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'

import { ListItemData } from '../interfaces'

export const ListItem = ({ name, value }: ListItemData): JSX.Element => (
  <Flex
    justifyContent="space-between"
    padding="4px 6px"
    borderRadius="sm"
    css={{
      '&:nth-of-type(2n + 1)': { backgroundColor: 'green.a50' },
      '&:nth-of-type(2n)': { backgroundColor: 'white' },
    }}
  >
    <Text fontSize="sm" color="gray.a500" fontWeight={300}>
      {name}
    </Text>
    <Box paddingLeft="30px" flexShrink="0" fontSize="sm" color="gray.a500">
      {value}
    </Box>
  </Flex>
)
